import { Component,Output,ViewChild, EventEmitter, OnInit } from '@angular/core';
import { ExportsService } from "../../../../injections/exports.service";
import { Angular2Csv } from 'angular2-csv/Angular2-csv';
import * as moment from 'moment';

@Component({
  selector: 'export-services',
  templateUrl: '../../templates/partials/services-exports.html'
})
export class ExportServicesComponent implements OnInit{

    @ViewChild('dateFrom') dateFrom;
    @ViewChild('dateSince') dateSince;

    public headerData:object = {
        date: "FECHA",
        n_hours: "Nº HORAS",
        cleaner_price: "PRECIO CLEANER",
        hour_price: "PRECIO HORA",
        legal_name: "RAZÓN SOCIAL",
        cleanerName: "NOMBRE CLEANER",
        email: "EMAIL",
        city: "CIUDAD",
        periodicity: "PERIODICIDAD"
    }

    public buttonDisabled = false;

    constructor(private exportsService: ExportsService){}

    public closeSibiling(event){
        if(event == "desde"){
            this.dateSince.opened = false;
        }else if(event == "hasta"){
             this.dateFrom.opened = false;
        }
    }

    public exportActualWeek() {
        this.buttonDisabled = true;
        var dateIni = moment().startOf('isoWeek').format("YYYY-MM-DD");
        var dateEnd = moment().endOf('isoWeek').format("YYYY-MM-DD");
        this.exportsService.exportServices(dateIni, dateEnd).subscribe(result => {
            this.parseCSV(dateIni, dateEnd, result);
        });
    }

    public exportActualMonth() {
        this.buttonDisabled = true;
        var dateIni = moment().startOf('month').format("YYYY-MM-DD");
        var dateEnd = moment().endOf('month').format("YYYY-MM-DD");
        this.exportsService.exportServices(dateIni, dateEnd).subscribe(result => {
            this.parseCSV(dateIni, dateEnd, result);
        });
    }

    public exportLast15Days() {
        this.buttonDisabled = true;
        var dateIni = moment().subtract(15, 'days').format("YYYY-MM-DD");
        var dateEnd = moment().subtract(1, 'days').format("YYYY-MM-DD");
        this.exportsService.exportServices(dateIni, dateEnd).subscribe(result => {
            this.parseCSV(dateIni, dateEnd, result);
        });
    }

    public exportServices(){
        var dateIni = (this.dateFrom.formatDate != null) ? moment(this.dateFrom.formatDate,"DD/MM/YYYY").format("YYYY-MM-DD") : '';
        var dateEnd = (this.dateSince.formatDate != null) ? moment(this.dateSince.formatDate,"DD/MM/YYYY").format("YYYY-MM-DD") : '';
        this.buttonDisabled = true;
        this.exportsService.exportServices(dateIni, dateEnd).subscribe(result => {
            this.parseCSV(dateIni, dateEnd, result);
        });
    }

    private parseCSV(dateIni, dateEnd, url) {
        window.open(url,'_blank');
        this.buttonDisabled = false;
        //var data = encodeURI(csv);
        /*var fileURL = URL.createObjectURL(csv);
        var link = document.createElement('a');
        link.setAttribute("href", fileURL);
        link.setAttribute('download', stringTitle);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        this.buttonDisabled = false;*/
      }

    ngOnInit() {
        this.dateFrom.dt = moment().subtract(7, 'days').toDate();
        this.dateSince.dt = moment().add(7, 'days').toDate();
    }

}


// WEBPACK FOOTER //
// ./src/app/modules/exports/components/dummy/services-exports.component.ts